import React from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
import { useMilitaryVerificationError } from '../../../contexts/MilitaryVerificationErrorContext';

export const MilitaryVerificationErrorBanner = () => {
  const { error, clearError } = useMilitaryVerificationError();

  if (!error) {
    return null;
  }

  return (
    /* Shrink to the message, but never past a readable line. `max-w-max` did
    /* only the first half: max-content is the width the copy would take with no
    /* wrapping at all, so a short message hugged its text and a long one
    /* refused to wrap - the access-denied copy ran as one ~1000px line across
    /* the content column (MYA2-494).
    /*
    /* `w-fit` keeps the hugging, so every message that already fit renders
    /* unchanged; `max-w-2xl` is the cap that makes a longer one wrap instead
    /* (67.2rem = 672px - SUI roots the page at 62.5%, so 1rem is 10px). Capping
    /* a fit-content box rather than an explicit width is what keeps it inert on
    /* a narrow viewport: there the box is already the container, so the cap
    /* never binds and there is nothing to overflow. */
    <div className="sui-mb-4 sui-w-fit sui-max-w-2xl">
      <Alert
        status={error.status || 'error'}
        headline={error.headline}
        onClose={clearError}
        size="large"
      >
        {error.message}
      </Alert>
    </div>
  );
};

MilitaryVerificationErrorBanner.displayName = 'MilitaryVerificationErrorBanner';
